(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumaflex-essential-pro-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumaflex-essential-pro-buy')) {
    class LumaflexEssentialProBuy extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.pending = false;
        this.redirecting = false;
        this.form = this.querySelector('.lf-buy__form');
        this.select = this.querySelector('[data-variant-select]');
        this.button = this.querySelector('[data-add-button]');
        this.buttonText = this.querySelector('[data-button-text]');
        this.price = this.querySelector('[data-price]');
        this.compare = this.querySelector('[data-compare-price]');
        this.compareValue = this.querySelector('[data-compare-value]');
        this.error = this.querySelector('[data-form-error]');
        this.productImage = this.querySelector('[data-product-image]');
        if (!this.form || !this.button) return;

        const signal = this.controller.signal;
        if (this.select) {
          this.select.addEventListener('change', () => this.updateVariant(true), { signal });
          this.updateVariant(false);
        }
        if (this.dataset.ajaxEnabled === 'true' && window.fetch && window.FormData) {
          this.form.addEventListener('submit', (event) => this.addToCart(event), { signal });
        }
        window.addEventListener('pageshow', () => {
          this.pending = false;
          this.redirecting = false;
          this.setBusy(false);
        }, { signal });
        this.setBusy(false);
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
        this.pending = false;
        this.redirecting = false;
      }

      updateVariant(clearError) {
        if (!this.select) return;
        const option = this.select.selectedOptions[0];
        if (!option) return;
        this.dataset.available = option.dataset.available;
        if (this.price) this.price.textContent = option.dataset.price || '';
        if (this.compare) {
          const hasCompare = this.dataset.showCompare === 'true' && !!option.dataset.compare;
          this.compare.hidden = !hasCompare;
          if (this.compareValue) this.compareValue.textContent = hasCompare ? option.dataset.compare : '';
        }
        if (this.productImage && this.dataset.imageFixed !== 'true' && option.dataset.image) {
          this.productImage.src = option.dataset.image;
          this.productImage.srcset = option.dataset.srcset || '';
          this.productImage.alt = option.dataset.imageAlt || '';
          if (option.dataset.imageWidth) this.productImage.width = Number(option.dataset.imageWidth);
          if (option.dataset.imageHeight) this.productImage.height = Number(option.dataset.imageHeight);
        }
        if (clearError) this.clearError();
        this.setBusy(this.pending);
      }

      setBusy(busy) {
        if (!this.button) return;
        const available = this.dataset.available === 'true';
        this.button.disabled = busy || !available;
        if (this.buttonText) {
          this.buttonText.textContent = busy
            ? this.dataset.addingLabel
            : (available ? this.dataset.buttonLabel : this.dataset.soldOutLabel);
        }
        if (this.select) this.select.disabled = busy;
        if (this.form) {
          if (busy) this.form.setAttribute('aria-busy', 'true');
          else this.form.removeAttribute('aria-busy');
        }
      }

      clearError() {
        if (!this.error) return;
        this.error.textContent = '';
        this.error.hidden = true;
      }

      async addToCart(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.pending || this.dataset.available !== 'true') return;
        this.clearError();
        const controller = this.controller;
        // Capture the selected ID before disabling the variant selector.
        const payload = new FormData(this.form);
        payload.delete('return_to');
        const endpoint = new URL(this.dataset.cartAddUrl || this.form.action, window.location.href);
        endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
        endpoint.hash = '';
        this.pending = true;
        this.setBusy(true);
        let publicMessage = this.dataset.errorLabel;

        try {
          const response = await fetch(endpoint.href, {
            method: 'POST',
            body: payload,
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            signal: controller.signal
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            publicMessage = typeof data.description === 'string'
              ? data.description
              : (typeof data.message === 'string' ? data.message : this.dataset.errorLabel);
            throw new Error(publicMessage);
          }
          if (controller.signal.aborted || this.controller !== controller) return;
          this.redirecting = true;
          window.location.assign(this.dataset.cartUrl);
        } catch {
          if (controller.signal.aborted || this.controller !== controller) return;
          if (this.error) {
            this.error.textContent = publicMessage;
            this.error.hidden = false;
          }
        } finally {
          if (this.controller === controller && !this.redirecting) {
            this.pending = false;
            this.setBusy(false);
          }
        }
      }
    }
    customElements.define('lumaflex-essential-pro-buy', LumaflexEssentialProBuy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumaflex-fda-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumaflex-fda-hero')) {
    class LumaflexFdaHero extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener('click', (event) => this.handleAnchor(event), {
          signal: this.controller.signal
        });
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
      }

      handleAnchor(event) {
        if (!(event.target instanceof Element)) return;
        const link = event.target.closest('a');
        if (!link || !this.contains(link) || link.target === '_blank') return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#') || href === '#') return;

        let target;
        try { target = document.getElementById(decodeURIComponent(href.slice(1))); }
        catch (error) { return; }
        if (!target) return;

        event.preventDefault();
        const nav = document.querySelector('lumaflex-fda-navigation[data-sticky="true"]');
        const bar = nav && nav.querySelector('.lf-nav__bar');
        let offset = Number(this.dataset.anchorOffset) || 0;
        if (bar) {
          offset = bar.getBoundingClientRect().height + (Number(nav.dataset.stickyOffset) || 0) + (Number(nav.dataset.anchorGap) || 0);
        }
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
        const animate = this.dataset.smoothScroll === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        try {
          if (window.location.hash !== href) window.history.pushState(null, '', href);
        } catch (error) {
          // Theme-editor previews may restrict history; scrolling still works.
        }

        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        window.scrollTo({ top, behavior: animate ? 'smooth' : 'instant' });
      }
    }
    customElements.define('lumaflex-fda-hero', LumaflexFdaHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumaflex-fda-mid-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumaflex-fda-mid-cta')) {
    class LumaflexFdaMidCta extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener('click', (event) => this.handleAnchor(event), {
          signal: this.controller.signal
        });
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
      }

      handleAnchor(event) {
        if (!(event.target instanceof Element)) return;
        const link = event.target.closest('a.lf-mid-cta__button');
        if (!link || !this.contains(link)) return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#') || href === '#') return;

        let target;
        try { target = document.getElementById(decodeURIComponent(href.slice(1))); }
        catch (error) { return; }
        if (!target) return;

        event.preventDefault();
        const nav = document.querySelector('lumaflex-fda-navigation[data-sticky="true"]');
        const bar = nav && nav.querySelector('.lf-nav__bar');
        let offset = Number(this.dataset.anchorOffset) || 0;
        if (bar) {
          offset = bar.getBoundingClientRect().height + (Number(nav.dataset.stickyOffset) || 0) + (Number(nav.dataset.anchorGap) || 0);
        }
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
        const animate = this.dataset.smoothScroll === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        try {
          if (window.location.hash !== href) window.history.pushState(null, '', href);
        } catch (error) {
          // Theme-editor previews may restrict history; scrolling still works.
        }

        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        window.scrollTo({ top, behavior: animate ? 'smooth' : 'instant' });
      }
    }
    customElements.define('lumaflex-fda-mid-cta', LumaflexFdaMidCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumaflex-fda-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumaflex-fda-navigation')) {
    class LumaflexFdaNavigation extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.bar = this.querySelector('.lf-nav__bar');
        this.menu = this.querySelector('.lf-nav__mobile-menu');
        if (!this.bar) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.addEventListener('click', (event) => this.handleLink(event), options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.menu && this.menu.open) {
            this.menu.open = false;
            this.menu.querySelector('summary').focus();
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeMenu();
        }, options);
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.closeMenu();
        }, options);
        window.addEventListener('resize', () => {
          if (window.innerWidth >= 900) this.closeMenu();
          this.scheduleUpdate();
        }, options);

        if (this.dataset.sticky === 'true') {
          window.addEventListener('scroll', () => this.scheduleUpdate(), {
            passive: true,
            signal: this.controller.signal
          });
        }

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.scheduleUpdate());
          this.observer.observe(this.bar);
          this.observer.observe(this);
        }

        this.scheduleUpdate();
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.observer) this.observer.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.controller = null;
        this.observer = null;
        this.frame = null;
        this.classList.remove('is-fixed');
      }

      closeMenu() {
        if (this.menu) this.menu.open = false;
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.isConnected) return;

          const height = this.bar.getBoundingClientRect().height;
          const bounds = this.getBoundingClientRect();
          const topOffset = Number(this.dataset.stickyOffset) || 0;

          this.style.setProperty('--lf-nav-measured-height', `${height}px`);
          this.style.setProperty('--lf-nav-fixed-left', `${bounds.left}px`);
          this.style.setProperty('--lf-nav-fixed-width', `${bounds.width}px`);
          this.classList.toggle('is-fixed', this.dataset.sticky === 'true' && bounds.top < topOffset);
        });
      }

      handleLink(event) {
        if (!(event.target instanceof Element)) return;
        const link = event.target.closest('a');
        if (!link || !this.contains(link)) return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        this.closeMenu();
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#') || href === '#') return;

        let target;
        try {
          target = document.getElementById(decodeURIComponent(href.slice(1)));
        } catch (error) {
          return;
        }
        if (!target) return;

        event.preventDefault();
        const stickyHeight = this.dataset.sticky === 'true' ? this.bar.getBoundingClientRect().height : 0;
        const stickyOffset = this.dataset.sticky === 'true' ? Number(this.dataset.stickyOffset) || 0 : 0;
        const gap = Number(this.dataset.anchorGap) || 0;
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - stickyHeight - stickyOffset - gap);
        const animate = this.dataset.smoothScroll === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        try {
          if (window.location.hash !== href) window.history.pushState(null, '', href);
        } catch (error) {
          // Scrolling still works if an embedded preview restricts history.
        }

        const hadTabindex = target.hasAttribute('tabindex');
        if (!hadTabindex) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        window.scrollTo({ top, behavior: animate ? 'smooth' : 'instant' });
      }
    }

    customElements.define('lumaflex-fda-navigation', LumaflexFdaNavigation);
  }

  } catch(e) { console.error(e); }
})();
})();
